import { Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'

export const HydrateGuide = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 1')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t(
          'Click on the button below to go to the Liquidity page. Alternatively, you can go straight to the page on your own',
        )}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 2')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('Add liquidity for any token pair of any amount')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 3')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('If the above transaction is successful, you will earn EXP')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t(
          'Note: You can also earn EXP for this quest by completing a Flash LP transaction! You can do this on the Flash LP page',
        )}
      </Text>
    </>
  )
}
